import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router";
import { observer } from "mobx-react";
import CheckBox from "../../../shared/CheckBox";
import SearchPeek from "../../../searches/components/SearchPeek";
import { TagItemWithoutDelete } from "../../../ratecards/components/TagItem";

class SearchListItem extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      updated: false,
    };
  }

  render() {
    const props = this.props;

    const store = this.props.store;
    const expanded = this.props.expanded;
    const editing = this.props.editing || false;
    const selected = this.props.selected || false;
    const viewable = this.props.viewable;

    const search = props.search;

    const label = search.label;
    const title = search.title;
    const lastUpdated = search.lastUpdatedDisplay;
    const lastUpdatedDate = search.lastUpdatedDateDisplay;
    const industry = search.industry;
    const frequency = search.frequency.title;
    const id = search.id;

    const tags = search.tags;
    let tagSection = null;

    let onItemClick = this.props.itemClick;
    let expandable = this.props.expandable;

    let editingSection = null;
    if (editing) {
      editingSection = (
        <CheckBox
          type={store.allowMultipleItemSelection ? "checkbox" : "radio"}
          name="list-item-select"
          value={id}
          selected={selected}
          style={{ width: 34 }}
          onClick={onItemClick}
        />
      );
    }

    if (tags.length > 0) {
      tagSection = tags.map((tag) => <TagItemWithoutDelete key={tag.tagId} tag={tag} />);
    }

    let viewSection = null;
    if (viewable) {
      viewSection = (
        <div
          className="rc-center"
          onClick={(e) => {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
          }}
        >
          <Link
            to={{
              pathname: `/admin/searches/${search.searchId}`,
              state: { previousPath: this.context.router.location.pathname },
            }}
            className="btn btn-default"
          >
            View
          </Link>
        </div>
      );
    }

    let location = search.locationDetail();
    let tagCss = false;
    if (localStorage.getItem("isPtAdmin") === "true" || editing) {
      tagCss = true;
    }

    return (
      <div className="search-list-item-container">
        <div
          className={classNames("search-list-item", { selected: selected })}
          onClick={onItemClick}
        >
          <div className="search-list-item-left ellipsis">
            {editingSection}
            {expandable && (
              <div className="search-expand-state">
                <span
                  className={classNames("pt-ico-moon", {
                    expanded: this.props.expanded,
                  })}
                >
                  
                </span>
              </div>
            )}
            <div className="ellipsis">
              <div className="search-label ellipsis">{label}</div>
              <div className="search-title ellipsis">
                <span className="item-subtext-accent">{title} </span>
                <span className="item-subtext-muted"> in </span>
                <span className="item-subtext-accent">{location}</span>
              </div>
            </div>
          </div>
          <div className="search-list-item-right">
            <div className="search-info">
              <header>Industry</header>
              {industry.title}
            </div>
            <div className="search-info">
              <header>Rates from {lastUpdatedDate}</header>
              {lastUpdated}
            </div>
            <div className="search-info">
              <header>Rate Type</header>
              {frequency}
            </div>
            {viewSection}
          </div>
          <div className={classNames("tagbox", { "p-left-34": tagCss })}>
            {tagSection}
          </div>
        </div>
        {expandable && <SearchPeek store={store} expanded={expanded} search={search} />}
      </div>
    );
  }
}

export default observer(SearchListItem);

// WEBPACK FOOTER //
// src/views/searches/components/SearchListItem.jsx
